import axios from 'axios';
import queryString from 'query-string';
import { EventOccurrence } from 'services/events';
import useSWR from 'swr';

interface EventOccurrencesOptions {
  start_date_after?: number;
}

export const getEventOccurrences = async (
  eventId: string,
  options?: EventOccurrencesOptions
) => {
  const query = queryString.stringify(options ?? {});
  let occurrencesUrl = `${process.env.REACT_APP_EVENT_API_HOST}/api/v1/events/${eventId}/occurrences`;

  if (query) {
    occurrencesUrl += `?${query}`;
  }

  const response = await axios.get<EventOccurrence[]>(occurrencesUrl);

  return response?.data;
};

const useEventOccurrences = (eventId?: string) => {
  const { data, error, isValidating } = useSWR(
    eventId ? `workshop/event/${eventId}/occurrences` : null,
    () =>
      eventId ? getEventOccurrences(eventId, { start_date_after: 0 }) : null
  );
  const isLoading = !!(eventId && isValidating && !data);

  return {
    occurrences: data,
    error,
    isLoading
  };
};

export default useEventOccurrences;
